/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Meta_DescriptionInputs */

const es_landing_meta_description = /** @type {(inputs: Landing_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquila tu barco de lista séptima de manera legal hasta 3 meses al año. Registro sencillo y tramitación en capitanía incluida.`)
};

const gl_landing_meta_description = /** @type {(inputs: Landing_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aluga o teu barco de lista sétima de maneira legal ata 3 meses ao ano. Rexistro sinxelo e tramitación en capitanía incluída.`)
};

const en_landing_meta_description = /** @type {(inputs: Landing_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent out your List 7 boat legally for up to 3 months a year. Simple signup and harbour master paperwork included.`)
};

/**
* | output |
* | --- |
* | "Rent out your List 7 boat legally for up to 3 months a year. Simple signup and harbour master paperwork included." |
*
* @param {Landing_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_meta_description = /** @type {((inputs?: Landing_Meta_DescriptionInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Meta_DescriptionInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_meta_description(inputs)
	if (locale === "en") return en_landing_meta_description(inputs)
	return es_landing_meta_description(inputs)
});